import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Jay Kim</span>{" "}
            from <span className="purple">Atlanta, Georgia</span>.
            <br />
            I’m currently studying Computer Science at{" "}
            <span className="purple">Georgia State University</span>.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Guitar 🎸
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs ✍️
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Never stop learning, because life never stops teaching."{" "}
          </p>
          <footer className="blockquote-footer">Kirill Korshikov</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
